import { render, staticRenderFns } from "./InvestmentAdvisory.vue?vue&type=template&id=4d8a1ef3&"
import script from "./InvestmentAdvisory.vue?vue&type=script&lang=js&"
export * from "./InvestmentAdvisory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports